import { render, staticRenderFns } from "./MjTrueFalseTest.vue?vue&type=template&id=41b577ec&scoped=true&"
import script from "./MjTrueFalseTest.vue?vue&type=script&lang=js&"
export * from "./MjTrueFalseTest.vue?vue&type=script&lang=js&"
import style0 from "./MjTrueFalseTest.vue?vue&type=style&index=0&id=41b577ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b577ec",
  null
  
)

export default component.exports